import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-crown-tag',
  templateUrl: './crown-tag.component.html',
  styleUrls: ['./crown-tag.component.scss']
})
export class CrownTagComponent implements OnInit {
  @Input() icon: string;
  @Input() bgColor = '#7092BB';
  @Input() title: string;

  constructor() { }

  ngOnInit(): void {
  }

}
